import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  constructor(private apiService: ApiService, private http: HttpClient) {

  }

  getMeetingRooms(): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getReportMeetingRooms + '?locationId=' + locationId;
    const paramObj = {
    };
    return this.apiService.get(this.url, paramObj, {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getAccessPoints(): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getAccessPoints;
    const paramObj = {
      locationId: locationId
    };
    return this.apiService.get(this.url, paramObj, {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getDepartments(): Observable<any> {
    this.url = APIs.getDepartments;
    const paramObj = {
    };
    return this.apiService.get(this.url, paramObj, {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };


  getTenant(): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getTenant + '?locationId=' + locationId;
    const paramObj = {
    };
    return this.apiService.get(this.url, paramObj, {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };
  //getTenant

  getCheckInReports(AccessPointId, FromDate, ToDate, selectedTenantId): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getCheckins;
    const paramObj = {
      accessPointId: AccessPointId,
      fromDate: FromDate,
      toDate: ToDate,
      tenantId: selectedTenantId,
      locationId: locationId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getCreditReports(FromDate, ToDate, createdById, selectedTenantId): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getCreditReports;
    const paramObj = {
      fromDate: FromDate,
      toDate: ToDate,
      bookedBy: createdById,
      tenantId: selectedTenantId,
      locationId: locationId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getEmployeeReports(DepartmentId, FromDate, ToDate): Observable<any> {
    this.url = APIs.getEmployees;
    const paramObj = {
      departmentId: DepartmentId,
      fromDate: FromDate,
      toDate: ToDate
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getMeetingReports(meetingRoomId, FromDate, ToDate, BooKedBy, selectedTenantId): Observable<any> {
    this.url = APIs.getMeetings;
    let locationId = localStorage.getItem("locationId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? '';
    const paramObj = {
      meetingRoomId: meetingRoomId,
      fromDate: FromDate,
      toDate: ToDate,
      bookedBy: BooKedBy,
      tenantId: selectedTenantId,
      locationId: locationId,
      parkId: parkId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getMemberships(tenantId, FromDate, ToDate): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getMemberships;
    const paramObj = {
      tenantIds: tenantId,
      fromDate: FromDate,
      toDate: ToDate,
      locationId: locationId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getRfids(tenantId, FromDate, ToDate, pageNumber, pageSize): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? 1;
    this.url = APIs.getRfidList;
    const paramObj = {
      tenantIds: tenantId,
      fromDate: FromDate,
      toDate: ToDate,
      locationId: locationId,
      parkId: parkId,
      pageNo: pageNumber,
      size: pageSize,
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getSurveyReport(surveyType, FromDate, ToDate): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? '';
    this.url = APIs.getSurveyReportList;
    const paramObj = {
      surveyTypes: surveyType,
      fromDate: FromDate,
      toDate: ToDate,
      locationId: locationId,
      parkId: parkId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getFacilityReport(facilityType, FromDate, ToDate): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? '';
    this.url = APIs.getFacilytyReport;
    const paramObj = {
      facilityType: facilityType,
      fromDate: FromDate,
      toDate: ToDate,
      locationId: locationId,
      parkId: parkId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getFeedBackReport(url) {

    return this.apiService.get(url).pipe(map(response => {
      return response;
    }));
    // this.http refers to HttpClient. Note here that you cannot use the generic get<Blob> as it does not compile: instead you "choose" the appropriate API in this way.
    return this.http.get(this.url, { responseType: 'blob' });
  };

  getEmployeeReportsForEmp(body?: any): Observable<any> {
    return this.apiService.post(APIs.getEmployeesReportData, body, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };
}